import {Kit, Operation, OperationProfil, TypeOfMission} from "./Operation";
import {StoreLocation} from "./Store";
import {Cra} from "./Cra";
import {AdditionalTimes} from "./AdditionalTimes";
import {LogaProxy} from "./LogaProxy";
import {PearlsPlanningEntry} from "./PearlsPlanning";
import {PlanningMissionPurpose} from "./OrderRequest";

export class MissionAssignedBudgetQuotaDto {
  /**"code of the Operation Profile Template**/
  public tplCode: String;

  /**amount of quota assigned**/
  public amount: number;
  /** details about the amount **/
  public comment: String;

  /** date of computation of the quota**/
  public computeDate: Date;
}

export class Order {


  public static fromJson(json: Object): Order {
    let o: Order = new Order();

    o.id = json['missionId'];
    o.missionCode = json['missionCode'];
    o.operation = json['operation'];
    o.location = json['location'];

    o.csAuthor = json['csAuthor'];
    o.suiviReco = json['reco'];
    o.kit = json['kit'];
    o.profil = json['profil'];
    o.status = o.setStatus(json['status']);

    o.storeCustomerSectorName = json['storeCustomerSectorName'];
    o.storeCustomerSectorId = json['storeCustomerSectorId'];

    o.activities = []
    json['activities'].forEach(ooo => o.activities.push(Activity.fromJson(ooo)));

    o.typeOfMission = json['typeOfMission'];
    o.worker = json['worker'];
    o.createDate = json['createDate'];

    o.csPresence = json['csPresence'];
    o.appointment = json['appointment'];
    o.appointmentTime = json['appointmentTime'];
    o.sharingCustomerSectorContactDetailsToWorker = json['sharingCustomerSectorContactDetailsToWorker'];

    o.storeContact = json['storeContact'];
    o.mobileStoreContact = json['mobileStoreContact'];
    o.storeAccess = json['storeAccess'];

    o.comment = json['comment'];
    o.briefMissionDetails = json['briefMissionDetails'];

    o.cras = json['workDaysReportable'];
    o.customerFeedback = json['customerFeedback'];
    o.customerFeedbackComment = json['customerFeedbackComment'];

    o.presence = json['presence'];
    o.pcheckAlerts = json['pcheckAlert'];

    o.customerDeletePermissionAllowed = json['customerDeletePermissionAllowed'];
    o.customerEditPermissionAllowed = json['customerEditPermissionAllowed'];
    o.customerDeleteRequestPermissionAllowed = json['customerDeleteRequestPermissionAllowed'];
    o.cancellationRequest = json['cancellationRequest'];

    o.storeAliasClientCode = json['storeAliasClientCode'];

    o.assignedQuota = json['assignedQuota'];

    // depreacated
    //o.planningPurpose = json['planningPurpose'];
    o.dailyTourPlanning = json['dailyTourPlanning'];
    o.plannedPurposes = json['plannedPurposes'];
    return o;
  }

  public id: number;
  public missionCode: string;
  public status: OrderStatus;
  public createDate: Date;
  public suiviReco: boolean;
  public operation: Operation;
  public location: StoreLocation;
  public kit: Kit;
  public activities: Activity[];
  public csAuthor: string;
  public profil: OperationProfil;
  public typeOfMission: TypeOfMission;
  public worker: AssignedWorkerDetails;

  public storeCustomerSectorName: string;
  public storeCustomerSectorId: number;

  public csPresence: boolean;
  public appointment: string;
  public appointmentTime: Date;

  public customerDeletePermissionAllowed: boolean;
  public customerDeleteRequestPermissionAllowed: boolean;
  public customerEditPermissionAllowed: boolean;

  public sharingCustomerSectorContactDetailsToWorker: boolean;

  public storeContact: string;
  public mobileStoreContact: string;
  public storeAccess: string;

  public comment: string;
  public briefMissionDetails: string;

  public dailyTourPlanning: DailyTourPlanning;

  // enum value GOOD, MEDIUM....
  public customerFeedback: string;
  public customerFeedbackComment: number;
  public uiIncidentDeclared: boolean;

  public additionalTimes: AdditionalTimes[] = [];

  public presence: boolean;
  public pcheckAlerts: String[] = [];

  public cras: Cra[];

  public storeAliasClientCode: string;
  public storeAliasResourcePool: string;

  public assignedQuota: MissionAssignedBudgetQuotaDto[] = [];

  /**
   * utitility flag to show/hide content with simple filtering
   */
  public uiShouldHide: boolean;

  /**
   * ui flag to cache presence check status as human readable string, will not come from the API
   */
  public uiPresenceCheckString: string;

  public cancellationRequest: MissionCustomerCancellationDetails;

  public planningPurpose: LogaProxy;
  public plannedPurposes: PlanningMissionPurpose[];

  getStartDate(): Date {
    if (this.activities) {
      let activity = this.activities.reduce((prev, curr) =>
        prev.amStartTime != null && curr.amStartTime != null && prev.amStartTime.valueOf() < curr.amStartTime.valueOf() ? prev : curr);

      if (activity.amStartTime == null && activity.amEndTime == null) {
        activity = this.activities.reduce((prev, curr) => prev.pmStartTime != null && curr.pmStartTime != null && prev.pmStartTime.valueOf() < curr.pmStartTime.valueOf() ? prev : curr);
        return activity.pmStartTime;
      } else {
        return activity.amStartTime;
      }

    }
  }

  getEndDate(): Date {
    if (this.activities) {
      let activity = this.activities.reduce((prev, curr) =>
        prev.pmEndTime != null && curr.pmEndTime != null && prev.pmEndTime.valueOf() > curr.pmEndTime.valueOf() ? prev : curr);

      return activity.pmEndTime;
    }
  }

  /**
   * Get duration time in minute for this order
   */
  getDuration(): number {
    if (this.activities) {

      let nbMinAm: number = 0;
      let nbMinPm: number = 0;

      this.activities.forEach(act => {

        if (act.amStartTime && act.amEndTime)
          nbMinAm += Math.abs(act.amEndTime.valueOf() - act.amStartTime.valueOf()) / (1000 * 60);

        if (act.pmStartTime && act.pmEndTime)
          nbMinPm += Math.abs(act.pmEndTime.valueOf() - act.pmStartTime.valueOf()) / (1000 * 60);

      });

      return Math.abs(Number(nbMinAm) + Number(nbMinPm));
    }
  }


  getActivityDuration(act: Activity) {
    let nbMinAm: number = 0;
    let nbMinPm: number = 0;
    if (act.amStartTime && act.amEndTime)
      nbMinAm += Math.abs(act.amEndTime.valueOf() - act.amStartTime.valueOf()) / (1000 * 60);

    if (act.pmStartTime && act.pmEndTime)
      nbMinPm += Math.abs(act.pmEndTime.valueOf() - act.pmStartTime.valueOf()) / (1000 * 60);
    return Math.abs(Number(nbMinAm) + Number(nbMinPm));
  }

  toHrStatus(): string {
    if (this.status == null) return "";
    else if (this.status === OrderStatus.PENDING_VALIDATION) {
      return "En Attente de Validation";
    } else if (this.status === OrderStatus.VALIDATED)
      return "Validé";
    else if (this.status === OrderStatus.ASSIGNED)
      return "Affecté";
    else if (this.status === OrderStatus.REJECTED)
      return "Rejeté";
    else if (this.status === OrderStatus.FULFILLED)
      return "Réalisé";
    else if (this.status === OrderStatus.CANCELED)
      return "Annulé";
    else return "";
  }

  cssStatus(): string {

    if (this.status == null) return null;
    else if (this.status === OrderStatus.PENDING_VALIDATION) {
      return "pending-validation";
    } else if (this.status === OrderStatus.VALIDATED)
      return "validated";
    else if (this.status === OrderStatus.ASSIGNED)
      return "assigned";
    else if (this.status === OrderStatus.REJECTED)
      return "rejected";
    else if (this.status === OrderStatus.FULFILLED)
      return "fulfilled";
    else if (this.status === OrderStatus.CANCELED)
      return "canceled";
    else return "";
  }


  setStatus(status: string): OrderStatus {

    if (status === "ASSIGNED") {
      return OrderStatus.ASSIGNED;
    } else if (status === "PENDING_VALIDATION") {
      return OrderStatus.PENDING_VALIDATION;
    } else if (status === "VALIDATED") {
      return OrderStatus.VALIDATED;
    } else if (status === "CANCELED") {
      return OrderStatus.CANCELED;
    }

  }


  computeStart(act: Activity) {
    if (act.amStartTime != null) return act.amStartTime;
    if (act.pmStartTime != null) return act.pmStartTime;
    return null;
  }


}

export enum OrderStatus {
  PENDING_VALIDATION, VALIDATED, PREASSIGNED, ASSIGNED, IN_PROGRESS, FULFILLED, CANCELED, REJECTED
}


export class AssignedWorkerDetails {
  workerId: number;
  workerName: string;
  workerMobilePhone: string;
  workerEmail: string;
}

export class Activity {
  public id: number;
  public day: number;
  public amStartTime: Date;
  public amEndTime: Date;
  public pmStartTime: Date;
  public pmEndTime: Date;
  public recoCompliance: boolean;
  public comment: string;

  public dailyWorkerScheduleTemplateSlotId: number;
  public planningSlotId: number;

  static fromJson(a: Activity) {
    let act: Activity = new Activity();
    act.id = a.id;
    act.day = a.day;
    act.recoCompliance = a.recoCompliance;
    act.comment = a.comment;
    act.amStartTime = a.amStartTime == null ? null : new Date(a.amStartTime);
    act.amEndTime = a.amEndTime == null ? null : new Date(a.amEndTime);
    act.pmStartTime = a.pmStartTime == null ? null : new Date(a.pmStartTime);
    act.pmEndTime = a.pmEndTime == null ? null : new Date(a.pmEndTime);
    return act;
  }
}

export class MissionCustomerCancellationDetails {
  public author: String;

  public date: Date;

  public comments: string;

  public missionStatusAtRequest: string;

}

// ---- Order Planning Report

export class PlanningReportdayBadges {
  public label: string;
  public value: number;

  public children: PlanningReportdayBadges[] = [];

  public uiDisplayChildren: boolean;
}

export class PlanningEntry {
  public contextName: string;
  public operationName: string;

  public planningEntryType: string;
  public missions: Order[] = [];
  public pearlsPlanningEntries: PearlsPlanningEntry[] = [];

}

export class PlanningOperationDayReport {
  public label: string;
  public operationId: number;
  public operationCode: string;

  public badges: PlanningReportdayBadges[] = [];

  public planningEntry: PlanningEntry;

  fromJson(oo: PlanningOperationDayReport): PlanningOperationDayReport {

    let r = new PlanningOperationDayReport();
    r.label = oo.label;
    r.operationCode = oo.operationCode;
    r.operationId = oo.operationId;
    r.badges = oo.badges;

    r.planningEntry = new PlanningEntry();
    r.planningEntry.planningEntryType = oo.planningEntry.planningEntryType;
    oo.planningEntry.missions.forEach(mm => r.planningEntry.missions.push(Order.fromJson(mm)));
    oo.planningEntry.pearlsPlanningEntries.forEach(sc => r.planningEntry.pearlsPlanningEntries.push(PearlsPlanningEntry.fromJson(sc)));

    return r;
  }
}

export class PlanningReportDay {
  public label: string;
  public logaDay: number;
  public operationReports: PlanningOperationDayReport[] = [];

  public dailyTourPlannings: DailyTourPlanning[] = [];

  fromJson(o: PlanningReportDay): PlanningReportDay {
    let r = new PlanningReportDay();
    r.label = o.label;
    r.logaDay = o.logaDay;
    r.operationReports = [];
    o.operationReports.forEach(oo => r.operationReports.push(new PlanningOperationDayReport().fromJson(oo)));

    r.dailyTourPlannings = [];
    o.dailyTourPlannings.forEach(oo => r.dailyTourPlannings.push(new DailyTourPlanning().fromJson(oo)))
    return r;
  }
}

export class CustomerFeedbackUpdateRequest {
  public customerFeedback: String;
  public customerFeedbackComment: String;

  fromJson(o: CustomerFeedbackUpdateRequest): CustomerFeedbackUpdateRequest {
    let r = new CustomerFeedbackUpdateRequest();
    r.customerFeedback = o.customerFeedback;
    r.customerFeedbackComment = o.customerFeedbackComment;

    return r;
  }
}

export class MissionOrderPlanningReport {

  public days: PlanningReportDay[] = [];

  private allOrders: Order[] = [];

  private allPearlsPlannings: PearlsPlanningEntry[] = [];

  fromJson(o: MissionOrderPlanningReport): MissionOrderPlanningReport {
    const r = new MissionOrderPlanningReport();
    r.days = [];

    o.days.forEach(o =>
      r.days.push(new PlanningReportDay().fromJson(o)));

    return r;
  }

  findOrderById(orderId: number): Order {
    if (this.days != null)
      for (let day of this.days)
        if (day.operationReports != null)
          for (let opR of day.operationReports)
            if (opR.planningEntry.missions != null)
              for (let m of opR.planningEntry.missions)
                if (m.id == orderId)
                  return m;
    return null;
  }

  getAllOrders(): Order[] {
    if (this.allOrders == null || this.allOrders.length <= 0) {
      let r = [];

      if (this.days != null)
        this.days.forEach(day => {
          if (day.operationReports != null) {
            day.operationReports.forEach(opR => {
              if (opR.planningEntry.missions != null)
                opR.planningEntry.missions.forEach(m => {
                  r.push(m);
                })
            });
          }
        })
      this.allOrders = r;
    }
    return this.allOrders;
  }

  getAllPearlsPlannings(): PearlsPlanningEntry[] {
    if (this.allPearlsPlannings == null || this.allPearlsPlannings.length <= 0) {
      let r = [];

      if (this.days != null)
        this.days.forEach(day => {
          if (day.operationReports != null) {
            day.operationReports.forEach(opR => {
              if (opR.planningEntry.pearlsPlanningEntries != null)
                opR.planningEntry.pearlsPlanningEntries.forEach(m => {
                  r.push(m);
                })
            });
          }
        })
      this.allPearlsPlannings = r;
    }
    return this.allPearlsPlannings;
  }
}

export class DailyPlanningMissionOrderPlanningReport extends MissionOrderPlanningReport {
  tourId: number;
  tourName: string;
  tourCode: string;
  logaDay: number;

  fromJson(o: DailyPlanningMissionOrderPlanningReport): DailyPlanningMissionOrderPlanningReport {
    const r = new DailyPlanningMissionOrderPlanningReport();

    r.days = [];
    o.days.forEach(o =>
      r.days.push(new PlanningReportDay().fromJson(o)));

    r.tourId = o.tourId;
    r.tourName = o.tourName;
    r.tourCode = o.tourCode;
    r.logaDay = o.logaDay;

    return r;
  }
}


export class DailyTourPlanning {
  id: number;
  name: string;
  code: string;
  referenceDate: number;
  customerSector;

  fromJson(oo: DailyTourPlanning) {
    this.id = oo.id;
    this.name = oo.name;
    this.code = oo.code;
    this.referenceDate = oo.referenceDate;
    this.customerSector = oo.customerSector;
    return this;
  }
}




// WEBPACK FOOTER //
// ./src/model/Order.ts